import { useEmbedStore, EmbedSource } from '@/stores/embed-store';

interface EmbedModeResult {
  isEmbedded: boolean;
  embedSource: EmbedSource;
  workspaceId: string | null;
}

/**
 * Hook to access embed mode state.
 * Detects ?embed=optisigns URL param on initial load.
 * Returns { isEmbedded, embedSource, workspaceId }.
 */
export function useEmbedMode(): EmbedModeResult {
  const isEmbedded = useEmbedStore((s) => s.isEmbedded);
  const embedSource = useEmbedStore((s) => s.embedSource);
  const workspaceId = useEmbedStore((s) => s.workspaceId);

  return { isEmbedded, embedSource, workspaceId };
}
